import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryShowcase() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4">
            内容分类
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            探索更多精彩内容
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            覆盖下载指南、使用教程、安全知识等多个领域，助您全面了解008pg国际平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.slice(0, 6).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 bg-background-50 border border-background-200/70 rounded-2xl hover:border-secondary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center bg-secondary-100 rounded-xl group-hover:bg-secondary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-secondary-600 group-hover:text-background-50 text-lg transition-colors duration-300`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-secondary-700 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {cat.description}
                </p>
                <span className="text-xs text-secondary-500">
                  {cat.articleCount} 篇文章
                </span>
              </div>
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-line text-secondary-500"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}